import ComposeEmail from "../../mixins/compose-mail";
import CreatesInspection from "../../mixins/create-inspection-mixin";
import ArchivingMixin from "../../mixins/archiving-mixin";
import AssetInspectionList from "../../components/inspections/AssetInspectionList";

Vue.component("view-asset", {
    mixins: [require("../../mixins/address"), ComposeEmail, CreatesInspection, ArchivingMixin],

    components: {AssetInspectionList},

    props: {
        asset: {},
        assetGroups: {},
        tickets: {},
        leases: {}
    },
    data () {
        return {
            mutableAsset: {},
            createButtonName: "",
            showCreateTicketModal: false,
            showCreateInspectionModal: false,
            mutableTickets: this.tickets
        };
    },
    created () {
        this.mutableAsset = this.asset;
    },
    mounted () {
        let self = this;
        Bus.$on("asset-updated", function (asset) {
            self.mutableAsset = asset;
        });
    },
    computed: {
        contactsUrl () {
            return "/contacts/asset/" + this.mutableAsset.id;
        }
    },
    methods: {
        showMergeModal () {
            $("#merge-property-modal").modal("show");
        },
        hideMergeModal () {
            $("#merge-property-modal").modal("hide");
        },
        redirectToIndex () {
            window.location = "/assets";
        },
        addressUpdated (address) {
            this.mutableAsset.address = address;
        },
        goToTicket (ticketId) {
            window.open("/tickets/" + ticketId, "_blank");
        },
        restoreDeletedTicket (ticketId) {
            App.patch("/tickets/" + ticketId + "/restore", new AppForm({}))
            .then((response) => {
                let index = this.mutableTickets.findIndex(i => i.id === response.id);
                this.mutableTickets.splice(index, 1, response);
                toastr.success("Ticket has been restored");
            })
            .catch(() => {
                toastr.error("Could not restore ticket!");
            });
        },
        afterArchiving (archiving) {
            if (archiving) {
                this.mutableAsset.archived_at = this.$dayjs();
            } else {
                this.mutableAsset.archived_at = null;
            }
        },
        showTicketOrInspectionModal () {
            if (this.createButtonName.includes("Ticket")) {
                this.showCreateTicketModal = true;
            } else if (this.createButtonName.includes("Inspection")) {
                this.$refs.inspectionCreateFormOnAsset.showInspectionCreateForm();
            }
        },
        setCreateButtonName (tabName = null) {
            if (tabName !== null) {
                switch (tabName) {
                    case("Tickets"):
                        this.createButtonName = "New Ticket";
                        break;
                    case("Inspections"):
                        this.createButtonName = "New Inspection";
                        break;
                }
            } else {
                this.createButtonName = "";
            }
        },
        navigateToNewTicket (newTicket) {
            window.location = "/tickets/" + newTicket.id;
        },
        navigateToNewInspection (newInspection) {
            this.hideInspectionCreateForm(); // located in the create-inspection-mixin
            window.location = "/inspections/" + newInspection.id;
        },
        navigateToActivityLog (assetId) {
            window.location.href = `/activity-log?id=${assetId}&type=Asset`;
        }
    },
});
